import React, { useState, useEffect, useCallback } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Count, Loading, DatePicker } from '../../components/all';
import useAula from '../../hooks/useAula';
import useAulaStore from '../../store/useAulaStore';
import { format, isBefore, addDays, isAfter, set, subHours } from 'date-fns';
import { formatarDataParaSalvar } from '../../utils/dataFormat';
import toast from '../../utils/toast';

export default function SelectDateAndHour() {
  const { SearchAndFilterHour } = useAula();

  const navigate = useNavigate();
  const [initialLoading, setInitialLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [horas, setHoras] = useState([]);
  const [error, setError] = useState(null);
  const [currentTime, setCurrentTime] = useState(null);
  const [date, setDate] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedHour, setSelectedHour] = useState(null);
  const [currentDate, setCurrentDate] = useState(null);
  const [dayName, setDayName] = useState('');

  const { updateAula, aula } = useAulaStore.getState();
  const instrutor = aula?.instrutor?.instrutor_id;
  const veiculo = aula?.veiculo?.veiculo_id;

  const namesForDays = ["Erro", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado", "Domingo"];


  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const now = new Date().toISOString();
        const dataAtual = now.split('T');
        setCurrentDate(dataAtual[0]);
        setCurrentTime(dataAtual[1]);

        const response = await fetch('https://brasilapi.com.br/api/feriados/v1/2024');
        if (!response.ok) throw new Error('Erro ao buscar feriados');

        const data = await response.json();
        setHolidays(data.map(h => h.date));
      } catch (error) {
        toast.error('Erro ao buscar os dados iniciais.');
        console.error(error);
      } finally {
        setInitialLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    if (!date) return;

    const fetchHours = async () => {
      let dataFunc = date;

      const hojeAs20 = set(new Date(), { hours: 20, minutes: 0, seconds: 0, milliseconds: 0 });
      const agora = new Date();

      if (isAfter(agora, hojeAs20)) {
        dataFunc = subHours(new Date(dataFunc), 3);
      }

      const dayOfWeek = format(dataFunc, 'i');
      setDayName(namesForDays[dayOfWeek]);

      if (+dayOfWeek === 6 || +dayOfWeek === 7) {
        setHoras([]);
        return;
      }

      setLoading(true);
      try {
        const result = await SearchAndFilterHour(instrutor, veiculo, dataFunc);
        setHoras(result);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchHours();
  }, [date, instrutor, veiculo, SearchAndFilterHour]);

  const handleDateChange = (selectedDate) => {
    if (isAfter(currentDate, selectedDate)) {
      return;
    }
    // //console.log(selectedDate)
    if (!date) {
      setDate(selectedDate);
      return;
    }
    if (isAfter(selectedDate, addDays(currentDate, 7))) {
      toast.error('Data muito longe!');
      return;
    }

    setDate(selectedDate);
  };

  const handleHourClick = (hora) => {
    const selectedHourParsed = new Date(`1970-01-01T${hora}:00`); // Parse a hora
    if (isBefore(selectedHourParsed, new Date(currentTime)) && isBefore(date, new Date())) {
      toast.error('Hora anterior à atual. Escolha outro horário!');
    } else {
      setSelectedHour(hora);
      setModalVisible(true);
    }
  };

  const confirmSelection = () => {
    setModalVisible(false);
    updateAula('hora', selectedHour);
    const dataFormatada = formatarDataParaSalvar(date)
    updateAula('data', dataFormatada);
    // //console.log(selectedHour, " asdasdda ", dataFormatada)
    navigate('/confirmar');
  };

  if (initialLoading) {
    return <Loading visible />;
  }

  return (
    <div className='flex flex-col min-h-screen min-h-[100dvh] w-full p-4 sm:p-5 max-w-[800px] items-center pt-6 pb-24'>
      <h1 className='font-bold text-2xl mb-4 mt-5'>Selecionar data e hora</h1>
      <h2 className='mb-4'>Mude a data e escolha a hora!</h2>
      <p>{dayName || ""}</p>
      <DatePicker
        onChange={handleDateChange}
        dias={7}
      />
      <Loading visible={loading} />
      {error && <p className='text-error'>{error}</p>}

      <h1 className='font-semibold mt-3'>Horários disponíveis:</h1>
      <div className='flex flex-col gap-5 mt-3 h-full w-full items-center max-h-[45dvh] sm:max-h-[400px] overflow-y-auto pb-20'>
        {holidays.includes(format(date, 'yyyy-MM-dd')) ||
          format(date, 'i') === 7 ||
          format(date, 'i') === 6 ? (
          <div className='container-error'>
            <p className='text-error'>
              {'Nenhum horário disponível essa data!'}
            </p>
          </div>
        ) : horas.length > 0 ? (
          horas.map((hora, index) => (
            <Button back={'#4B003B'} className='w-full max-w-[300px]' key={index} onClick={() => handleHourClick(hora)}>
              {hora}
            </Button>
          ))
        ) : (
          <div className='flex flex-col h-full justify-center items-center'>
            <span className="material-icons !text-6xl text-red-600">
              warning
            </span>
            <p className='text-lg sm:text-xl text-red-600 font-medium text-center'>
              {'Nenhum horário disponível essa data!'}
            </p>
          </div>
        )}
      </div>


      <Modal isOpen={modalVisible}>
        <p className='text-center'>Você tem certeza que deseja selecionar essa <br/>data: <strong>{format(date, 'dd/MM/yyyy')} </strong>  ás <strong>{selectedHour}</strong> </p>
        <div className='grid grid-cols-2 gap-3 mt-4'>
          <Button onClick={confirmSelection} type={4}>Sim
            <span className="material-icons">
              check
            </span></Button>
          <Button onClick={() => setModalVisible(false)} type={3}>Não
            <span className="material-icons">
              close
            </span></Button>
        </div>
      </Modal>
      <Count className='bottom-0' num={4} />
      <ToastContainer />
    </div>
  );
}
